import { render, staticRenderFns } from "./MarketplaceContractSidebar.vue?vue&type=template&id=24c172b8&scoped=true&"
import script from "./MarketplaceContractSidebar.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContractSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c172b8",
  null
  
)

export default component.exports